import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy-page">
      <Navigation 
        showDemoButton={false}
        secondaryButtonText="Back to Home"
        onSecondaryClick={() => navigate('/')}
        trackingLocation="privacy_page"
      />
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p><strong>Effective Date:</strong> October 8, 2025</p>
          <p><strong>Last Updated:</strong> October 8, 2025</p>
        </div>
        
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Solidly Finance ("we," "us," or "our") respects your privacy. This Privacy Policy explains how we handle your information when you use the Solidly Finance desktop application ("the App").
            </p>
            <p>
              Our core principle is simple: <strong>your data is yours.</strong> Solidly Finance is designed to run entirely on your device. We do not collect, store, or transmit your personal financial data to any servers we control.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Do Not Collect</h2>
            <p>We do <strong>not</strong> collect or have access to any of the following:</p>
            <ul>
              <li>Your financial data, accounts, or personal records entered into the App</li>
              <li>Identifiable information such as your name, email address, or location. Your name and email are only used for support purposes and to verify your purchase.</li>
            </ul>
            <p>All data you enter into the App remains <strong>securely stored on your device only</strong>.</p>
          </section>

          <section className="privacy-section">
            <h2>3. Local Data Storage</h2>
            <p>The App stores your financial information in an encrypted local file on your computer.</p>
            <ul>
              <li><strong>Encryption:</strong> Your data is encrypted and protected by your chosen password.</li>
              <li><strong>No Cloud Syncing:</strong> We do not provide cloud storage, backups, or synchronization.</li>
              <li><strong>Your Responsibility:</strong> You are responsible for managing your backups and protecting access to your device and password.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Software Updates</h2>
            <p>
              The App may periodically check for available updates to ensure you receive new features and security improvements. This process may involve minimal, non-identifying communication with our update server (for example, the App version number). No personal or financial data is ever transmitted.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Purchases</h2>
            <p>
              Purchases of Solidly Finance are processed securely through our payment provider (e.g., Stripe, Paddle, or equivalent). We do not collect or store your payment information. Please refer to the payment processor's privacy policy for details on how your payment data is handled.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Support Inquiries</h2>
            <p>
              If you contact us for support, we may collect your email address and details you voluntarily provide to resolve your issue. We do not link this information to any data within the App.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Your Rights</h2>
            <p>
              Because we do not collect or store your data, there is no data to access, modify, or delete on our servers. You can delete your own data at any time by removing the App or its associated files from your computer.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Updates will be posted on our website at solidly.ai. The "Last Updated" date at the top reflects the date of the most recent changes.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Contact</h2>
            <p>For any questions about this Privacy Policy, please contact:</p>
            <div className="contact-info">
              <p><strong>SolidlyAI</strong></p>
              <p>Email: <a href="mailto:support@solidly.ai">support@solidly.ai</a></p>
              <p>Website: <a href="https://get.solidly.ai">get.solidly.ai</a></p>
            </div>
          </section>
        </div>
        
        <div className="back-to-home">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;